import React from 'react';
export default function Rule() {
    return React.createElement("hr", null);
}
//# sourceMappingURL=rule.js.map